import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InteractionLogService } from '../services/interaction-log.service';
import { LocalStorageService } from '../services/local-storage.service';

@Component({
  selector: 'app-interaction-log',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './interaction-log.component.html',
  styleUrl: './interaction-log.component.scss',
})
export class InteractionLogComponent implements OnInit {
  constructor(
    private interactionLogService: InteractionLogService,
    private localStorage: LocalStorageService
  ) {}

  allInteraction: any[] = [];
  showAllComments: boolean[] = [];
  userId: any;
  showModal: boolean = false;

  page = 0;
  pageSize = 10;
  hasMore = true;
  totalPages = 0;

  ngOnInit() {
    this.userId = this.localStorage.getItem('userId');
    this.getAllInteractions();
  }

  getAllInteractions() {
    const params = {
      page: this.page,
      size: this.pageSize,
      sort: 'updatedAt,desc',
    };

    this.interactionLogService.allInteractions(params).subscribe(
      (response) => {
        const content = response.content;
        this.allInteraction = content;
        this.showAllComments = this.allInteraction.map(() => false);
        this.hasMore = content.length === this.pageSize;
        this.totalPages = response.totalPages;
        this.editInteraction = this.allInteraction[0];
      },
      (err) => {
        console.error('Failed to fetch interactions', err);
      }
    );
  }

  nextPage() {
    this.page++;
    this.getAllInteractions();
  }

  prevPage() {
    if (this.page > 0) {
      this.page--;
      this.getAllInteractions();
    }
  }

  toggleComments(index: number) {
    this.showAllComments[index] = !this.showAllComments[index];
  }

  openModal() {
    this.showModal = true;
    const modal = document.getElementById('interactionModal');
    if (modal) modal.style.display = 'block';
  }

  onInteractionSaved() {
    this.getAllInteractions(); // Refresh list
  }

  selectedInteraction: any = null;
  newCommentText: string = '';

  openCommentModal(interaction: any) {
    this.selectedInteraction = interaction;
    this.newCommentText = '';
    const modal = document.getElementById('commentModal');
    if (modal) modal.style.display = 'block';
  }

  closeCommentModal() {
    this.selectedInteraction = null;
    const modal = document.getElementById('commentModal');
    if (modal) modal.style.display = 'none';
  }

  submitComment() {
    if (!this.newCommentText.trim()) return;

    const commentDTO = {
      comment: this.newCommentText,
      logId: this.selectedInteraction.id,
      createdBy: this.userId,
    };

    this.interactionLogService
      .saveInteractionLogComment(commentDTO)
      .subscribe((newComment) => {
        this.selectedInteraction.comments =
          this.selectedInteraction.comments || [];
        this.selectedInteraction.comments.push({
          ...newComment,
          comment: this.newCommentText, // ensure the text is present
        });
        this.newCommentText = '';
      });
  }

  editInteraction: any = null;

  nextActions = [
    'Call Tomorrow',
    'Send Quotation',
    'Schedule Site Visit',
    'Follow-Up Next Week',
    'Awaiting Customer Response',
    'Escalate to Manager',
    'Send Product Catalog',
    'Close Interaction',
    'No Further Action Needed',
  ];

  outcomeStatuses = [
    'Order_Placed',
    'Deal_In_Progress',
    'Follow_Up_Required',
    'Deal_Rejected',
    'Not_Reachable',
    'Information_Shared',
    'No_Response',
  ];

  openEditModal(interaction: any) {
    this.editInteraction = { ...interaction };
    const modal = document.getElementById('editModal');
    if (modal) modal.style.display = 'block';
  }

  closeEditModal() {
    this.editInteraction = null;
    const modal = document.getElementById('editModal');
    if (modal) modal.style.display = 'none';
  }

  submitUpdate() {
    if (!this.editInteraction) return;

    const updatePayload = {
      id: this.editInteraction.id,
      callNotes: this.editInteraction.callNotes,
      outcomeStatus: this.editInteraction.outcomeStatus,
    };

    this.interactionLogService.saveInteraction(updatePayload).subscribe(() => {
      this.closeEditModal();
      this.onInteractionSaved();
    });
  }
}
